(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-notifications-checker/assets/javascripts/player-notifications-checker.js') >= 0) return;  svs.modules.push('/components/accountservices/player-notifications-checker/assets/javascripts/player-notifications-checker.js');
"use strict";


svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.player_notifications_checker = svs.accountservices.player_notifications_checker || {};
(function (svs) {
  'use strict';

  const logger = svs.core.log.getLogger('accountservices:player-notifications-checker');
  const playerNotificationsCheckerEvents = new svs.utils.Events({});
  let customerSettings = {};
  const reminderTypes = {
    emailNotVerified: 1,
    cellphoneNotVerified: 2,
    emailAndCellphoneNotVerified: 3,
    emailMissing: 4,
    emailBounced: 5
  };
  let shownTypes = [];
  let refreshRetries = 0;
  const refreshMaxRetries = 5;
  const refreshRetryDelay = 800;
  let oldCustomerSettings = {};

  function checkPlayerNotifications() {
    svs.core.userSession.get('playerNotifs_customerSettings', (error, data) => {
      if (error) {
        logger.info('Error getting customer settings from userSession, ', error);
      } else if (data) {
        customerSettings = mapCustomerSettingsAtGet(data); 
        logger.debug("Getted data from userSession: ".concat(JSON.stringify(customerSettings)));
        createPlayerNotifications();
      } else {
        fetchPlayerNotifications(createPlayerNotifications);
      }
    });
  }

  function fetchPlayerNotifications(callback) {
    const options = {
      method: 'GET',
      path: '/player/2/customizedsettings'
    };
    let custProp;
    let contactInfoStatus;
    if (svs.utils.ns.isNamespace('svs.accountservices.player_notifications_checker.data.contactInfoStatus', window)) {
      contactInfoStatus = svs.accountservices.player_notifications_checker.data.contactInfoStatus;
    } else {
      logger.info('Constant contactInfoStatus is missing in response from server');
      return;
    }
    svs.core.jupiter.call(options, data => {
      try {
        if (data) {
          if (data.customizedSettings) {
            if (data.customizedSettings.properties) {
              custProp = data.customizedSettings.properties;
            } else {
              logger.info('Missing properties object from /player/2/customizedsettings');
              return;
            }
          } else {
            logger.info('Missing customizedsettings object from /player/2/customizedsettings');
            return;
          }
        } else {
          logger.error('Empty response object from /player/2/customizedsettings');
          return;
        }
      } catch (e) {
        logger.error('Error parsing server response:', e);
        return;
      }
      customerSettings.emailRemoved = custProp.emailStatus === contactInfoStatus.deleted || custProp.emailStatus === contactInfoStatus.offeredVerificationExpired;
      customerSettings.emailBounce = custProp.emailStatus === contactInfoStatus.bounce;
      customerSettings.emailVerified = custProp.emailStatus === contactInfoStatus.verified || custProp.emailStatus === contactInfoStatus.notOfferedVerification;
      customerSettings.cellPhoneVerified = custProp.cellPhoneStatus === contactInfoStatus.verified || custProp.cellPhoneStatus === contactInfoStatus.notOfferedVerification;
      customerSettings.cellPhoneExists = Boolean(custProp.cellphone);
      customerSettings.email = custProp.email;
      customerSettings.cellphone = custProp.cellphone;
      svs.core.userSession.set('playerNotifs_customerSettings', mapCustomerSettingsForSave(), error => {
        if (error) {
          logger.info('Error setting customer settings in userSession, ', error);
          if (customerSettings) {
            callback && callback();
          }
        } else {
          callback && callback();
        }
      });
    }, xhr => {
      logger.info('Error getting users customized settings, ', xhr);
    });
  }

  function createPlayerNotifications() {
    let clearRemindLater = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (customerSettings.emailRemoved || customerSettings.emailBounce) {
      if (customerSettings.emailRemoved && (!isShown(reminderTypes.emailMissing) && !remindLaterSet(reminderTypes.emailMissing) || clearRemindLater)) {
        logger.debug('Customer with removed email');
        svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
          svs && svs.accountservices && svs.accountservices.player_notifications && svs.accountservices.player_notifications.bounce_or_no_email && svs.accountservices.player_notifications.bounce_or_no_email.showMissingEmailMessage(clearRemindLater);
        });
      } else if (customerSettings.emailBounce && (!isShown(reminderTypes.emailBounced) && !remindLaterSet(reminderTypes.emailBounced) || clearRemindLater)) {
        logger.debug('Customer with bouncing email');
        svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
          svs && svs.accountservices && svs.accountservices.player_notifications && svs.accountservices.player_notifications.bounce_or_no_email && svs.accountservices.player_notifications.bounce_or_no_email.showEmailBounceMessage(clearRemindLater, customerSettings.email);
        });
      }
    } else if (!customerSettings.emailVerified) {
      if (customerSettings.emailVerified || !customerSettings.emailVerified && (isShown(reminderTypes.emailNotVerified) || remindLaterSet(reminderTypes.emailNotVerified) && !clearRemindLater)) {
      } else {
        logger.debug('Customer with unverified email');
        svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
          svs && svs.accountservices && svs.accountservices.player_notifications && svs.accountservices.player_notifications.verify_contact_info && svs.accountservices.player_notifications.verify_contact_info.showVerifyEmailMessage(customerSettings, clearRemindLater);
        });
      }
    }
    if (!customerSettings.cellPhoneVerified) {
      if (customerSettings.cellPhoneVerified || !customerSettings.cellPhoneVerified && customerSettings.cellPhoneExists && (isShown(reminderTypes.cellphoneNotVerified) || remindLaterSet(reminderTypes.cellphoneNotVerified) && !clearRemindLater)) {
      } else {
        logger.debug('Customer with unverified cellphone');
        svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
          svs && svs.accountservices && svs.accountservices.player_notifications && svs.accountservices.player_notifications.verify_contact_info && svs.accountservices.player_notifications.verify_contact_info.showVerifyCellPhoneMessage(customerSettings, clearRemindLater);
        });
      }
    }
  }

  function mapCustomerSettingsForSave() {
    const debugObject = {
      emailRemoved: customerSettings.emailRemoved ? 1 : 0,
      emailBounce: customerSettings.emailBounce ? 1 : 0,
      emailVerified: customerSettings.emailVerified ? 1 : 0,
      cellPhoneVerified: customerSettings.cellPhoneVerified ? 1 : 0,
      cellPhoneExists: customerSettings.cellPhoneExists ? 1 : 0
    };
    logger.debug("Save data to userSession: ".concat(JSON.stringify(debugObject)));
    return {
      a: customerSettings.emailRemoved ? 1 : 0,
      b: customerSettings.emailBounce ? 1 : 0,
      c: customerSettings.emailVerified ? 1 : 0,
      d: customerSettings.cellPhoneVerified ? 1 : 0,
      e: customerSettings.cellPhoneExists ? 1 : 0,
      f: customerSettings.email,
      g: customerSettings.cellphone
    };
  }

  function mapCustomerSettingsAtGet(data) {
    return {
      emailRemoved: data.a === 1,
      emailBounce: data.b === 1,
      emailVerified: data.c === 1,
      cellPhoneVerified: data.d === 1,
      cellPhoneExists: data.e === 1,
      email: data.f,
      cellphone: data.g
    };
  }

  function checkEmail() {
    if (!isShown(reminderTypes.emailNotVerified)) {
      if (customerSettings.emailRemoved) {
        logger.debug('Customer with removed email');
        svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
          svs.accountservices.player_notifications.bounce_or_no_email.showMissingEmailMessage(true);
        });
      } else if (customerSettings.emailBounce) {
        logger.debug('Customer with bouncing email');
        svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
          svs.accountservices.player_notifications.bounce_or_no_email.showEmailBounceMessage(true, customerSettings.email);
        });
      } else if (!customerSettings.emailVerified) {
        logger.debug('Customer with unverified email');
        svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
          svs.accountservices.player_notifications.verify_contact_info.showVerifyEmailMessage(customerSettings.email, true);
        });
      }
    }
  }

  function checkCellphone() {
    if (!isShown(reminderTypes.cellphoneNotVerified)) {
      if (!customerSettings.cellPhoneVerified && customerSettings.cellPhoneExists) {
        logger.debug('Customer with unverified cellphone');
        svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
          svs.accountservices.player_notifications.verify_contact_info.showVerifyCellPhoneMessage(true);
        });
      }
    }
  }

  function remindLaterSet(type) {
    return Boolean(Boolean(svs.core.session.data.userSession.data.playerNotifs_remindLater) && _.find(svs.core.session.data.userSession.data.playerNotifs_remindLater, reminderType => type == reminderType));
  }

  function isShown(type) {
    if (type == reminderTypes.emailMissing) {
      return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.emailMissing == shownType) !== undefined;
    } else if (type == reminderTypes.emailBounced) {
      return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.emailBounced == shownType) !== undefined;
    } else if (type == reminderTypes.emailNotVerified) {
      return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.emailNotVerified == shownType || reminderTypes.emailAndCellphoneNotVerified == shownType) !== undefined;
    } else if (type == reminderTypes.cellphoneNotVerified) {
      return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.cellphoneNotVerified == shownType || reminderTypes.emailAndCellphoneNotVerified == shownType) !== undefined;
    }
    return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.emailAndCellphoneNotVerified == shownType) !== undefined;
  }

  function unShow(type) {
    logger.debug('Remove specific type of unverified contact info from shown array');
    if (shownTypes) {
      const types = shownTypes.filter(reminderType => reminderType !== type).concat([]);
      shownTypes = types;
    }
  }

  function closeToaster() {
    logger.debug('Close previous toaster');
    try {
      for (const key in svs.accountservices.player_notifications_checker.toaster) {
        if (svs.accountservices.player_notifications_checker.toaster.hasOwnProperty(key)) {
          svs.accountservices.player_notifications_checker.toaster[key].close();
        }
      }
    } catch (e) {
      logger.debug('svs.accountservices.player_notifications_checker.toaster not available');
    }
  }

  function clearShownTypes() {
    logger.debug('Remove all types of unverified contact info from shown array');
    shownTypes = [];
  }

  function refreshCustomerSettings() {
    logger.debug('Refresh customer settings');
    if (refreshRetries == 0) {
      oldCustomerSettings = Object.assign(oldCustomerSettings, customerSettings);
    }
    if (refreshRetries === refreshMaxRetries || JSON.stringify(customerSettings) != JSON.stringify(oldCustomerSettings)) {
      refreshRetries = 0;
      oldCustomerSettings = {};
    } else {
      refreshRetries++;
      setTimeout(() => {
        fetchPlayerNotifications(refreshCustomerSettings);
      }, refreshRetryDelay);
    }
  }

  playerNotificationsCheckerEvents.on('email', () => {
    logger.debug('Event email triggered');
    checkEmail();
  });

  playerNotificationsCheckerEvents.on('cellphone', () => {
    logger.debug('Event cellphone triggered');
    checkCellphone();
  });

  playerNotificationsCheckerEvents.on('refresh', () => {
    logger.debug('Event refresh triggered');
    refreshCustomerSettings();
  });

  playerNotificationsCheckerEvents.on('reset', () => {
    logger.debug('Event reset triggered');

    svs.core.userSession.remove('playerNotifs_remindLater', () => {
      refreshCustomerSettings();
    });
  });

  playerNotificationsCheckerEvents.on('clear', () => {
    logger.debug('Event clear triggered');

    svs.core.userSession.remove('playerNotifs_customerSettings', () => {
      svs.core.userSession.remove('playerNotifs_remindLater', () => {
        clearShownTypes();
        closeToaster();
        logger.debug('Cleared cache for customer settings and remind later');
      });
    });
  });
  try {
    Backbone.history.on('route', () => {
      logger.debug('Backbone navigation. Hide previous toaster and re-check player notifications');
      setTimeout(() => {
        checkPlayerNotifications();
      }, 500);
    });
  } catch (e) {
    logger.debug('No backbone at this page');
  }

  function closeToasters() {
    logger.debug('Close all toasters');
    for (const key in svs.accountservices.player_notifications_checker.toaster) {
      if (svs.accountservices.player_notifications_checker.toaster[key]) {
        svs.accountservices.player_notifications_checker.toaster[key].close();
      }
    }
  }
  svs.accountservices.player_notifications_checker.checkPlayerNotifications = checkPlayerNotifications;
  svs.accountservices.player_notifications_checker.remindLaterSet = remindLaterSet;
  svs.accountservices.player_notifications_checker.reminderTypes = reminderTypes;
  svs.accountservices.player_notifications_checker.unShow = unShow;
  svs.accountservices.player_notifications_checker.events = playerNotificationsCheckerEvents;
  svs.accountservices.player_notifications_checker.toaster = {};
  svs.accountservices.player_notifications_checker.customerSettings = () => customerSettings;
  svs.accountservices.player_notifications_checker.shownTypes = () => shownTypes;
  svs.accountservices.player_notifications_checker.closeToasters = closeToasters;

  svs.accountservices.player_notifications_checker.test = {
    fetchPlayerNotifications,
    createPlayerNotifications
  };
})(svs);

 })(window);